module.exports = __webpack_public_path__ + "img/banner2.68a28086.jpg";